import { BadgeMap } from 'components/ComposableTable/generators/TextBadgeCell';

export const statusToTextBadge: BadgeMap = {
  draft: {
    textColor: 'white',
    color: 'eclipse',
  },
  inactive: {
    textColor: 'white',
    color: 'sunrise',
  },
  active: {
    textColor: 'white',
    color: 'shamrock',
  },
};
